// extracted by mini-css-extract-plugin
module.exports = {"num":"NumberQuestion_num__2Md2s","dimension":"NumberQuestion_dimension__2Jw5K","error":"NumberQuestion_error__9dLkZ","error__text":"NumberQuestion_error__text__3C9_s"};